import { ArticleBuilder } from './../../models/builders/article.builder';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ClientBuilder } from '../../models/builders/client.builder';

@Injectable()
export class ClientApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }clients`;
  }

  getClients() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(
        map(ClientBuilder.fromList)
      );
  }

  getArticlesByClient(hash: any) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }/articles`)
      .pipe(
        map(ArticleBuilder.fromList)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/client-api.service.ts